<template>
  <div class="main">
    <!-- 数据面板 -->
    <data-tab :option="option"></data-tab>
    <el-row class="rowStyle borderBottomStyle">
      <el-col :span="10">
        <span style="margin-left:30px;margin-bottom:0px;">今年项目各状态的占比</span>
      </el-col>
      <el-col :span="14">
        <el-tabs class="tabsStyle pro-state" v-model="projectState" @tab-click="handleProjectStateChange">
          <el-tab-pane label="正在招募" name="0"></el-tab-pane>
          <el-tab-pane label="等待执行" name="1"></el-tab-pane>
          <el-tab-pane label="正在执行" name="4"></el-tab-pane>
          <el-tab-pane label="申请结项" name="5"></el-tab-pane>
          <el-tab-pane label="项目取消" name="2"></el-tab-pane>
          <el-tab-pane label="拒绝结项" name="6"></el-tab-pane>
          <el-tab-pane label="项目完结" name="7"></el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row class="rowStyle" style="margin-bottom: 16px;">
      <el-col :span="10">
        <div id="pie" style="width: 100%;height: 470px;"></div>
      </el-col>
      <el-col :span="14">
        <avue-crud :data="projectInfoByState" :option="projectTableOption" style="border:0px;min-height: 350px;"
                   @row-click="showProjectDetail"></avue-crud>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="projectTotal"
          @current-change="projectCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 第二页-->
    <el-row class="rowStyle1 borderBottomStyle">
      <el-col :span="14">
        <el-tabs class="tabsStyle1" v-model="reasonState" @tab-click="handleReasonChange">
          <el-tab-pane label="其他原因" name="no-reason"></el-tab-pane>
          <el-tab-pane v-for="reason in reasonOptions" :label="reason.name" :name="reason.code"
                       :key="reason.id"></el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="10">
        <span style="margin-left:30px;margin-bottom:0px;">客诉原因统计</span>
      </el-col>
    </el-row>
    <el-row class="rowStyle" style="margin-bottom: 16px;">
      <el-col :span="14">
        <avue-crud :data="feedBackInfoByReason" :option="feedBackTableOption" style="border:0px;min-height: 350px;"
                   @row-click="showFeedBack">
        </avue-crud>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="feedBackTotal"
          @current-change="feedBackCurrentChange">
        </el-pagination>
      </el-col>
      <el-col :span="10" style="position: relative;">
        <div id="radar" style="width:600px;height:400px;"></div>
        <div style="position: absolute;top: 5px;right: 32px;font-size: 12px;color:rgba(144,147,153,1);">2019年至今</div>
      </el-col>
    </el-row>

    <!-- 第三部分 -->
    <el-row class="rowStyle">
      <el-col :span="10">
        <span style="margin-left:30px;margin-bottom:0px;">响应时间</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="responseText">{{ responseText }}</span>
      </el-col>

      <el-col :span="14">
        <el-tabs class="tabsStyle" v-model="responseTimeTab" @tab-click="handleResponseTimeUnitChange">
          <el-tab-pane label="本周" name="week"></el-tab-pane>
          <el-tab-pane label="本月" name="month"></el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-row class="rowStyle">
      <div id="line" style="width:90%;height:400px;"></div>
    </el-row>
    <el-row class="rowStyle">
      <el-col :span="18" :offset="-4">
        <avue-crud :data="responseTimeInfoByUnit" :option="responseTimeTableOption" style="border:0px;"
                   @row-click="showProjectDetail"></avue-crud>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="responseTotal"
          @current-change="responseCurrentChange" class="leftpagination">
        </el-pagination>
      </el-col>
    </el-row>

    <!--第四部分-->
    <el-row class="rowStyle borderBottomStyle" style="margin-top: 16px;">
      <span style="margin-left:30px;margin-bottom:0px;">项目分布</span>
    </el-row>
    <el-row class="rowStyle">
      <el-col :span="10">
        <div id="chinaMap" style="width:600px;height:400px;"></div>
      </el-col>
      <el-col :span="14">
        <avue-crud :data="positionInfo" :option="positionTableOption" style="border:0px;"></avue-crud>
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :total="positionTotal"
          @current-change="positionCurrentChange">
        </el-pagination> -->
      </el-col>
    </el-row>
    <comment2 ref="childcomment"></comment2>
    <orderinfo2 ref="child"></orderinfo2>
  </div>
</template>

<script>
import {
  getPanelData,
  getPieData,
  getFeedBackInfo,
  getRadarData,
  getLineData,
  getProjectInfoByTimeUnit,
  getMapData,
  getPositionProjectInfo
} from '@/api/dataview/dataview'
import {fetchList} from '@/api/admin/taskManagement'
import {
  projectTableOption,
  feedBackTableOption,
  responseTimeTableOption,
  positionTableOption
} from '@/const/dataview/dataview'
import {objKeySort} from '@/util/ajaxsign'
import dataTab from './components/dataTab'
import {getDictListById} from '@/api/admin/dict'

import 'echarts/map/js/china'
import comment2 from "../../orderManager/comment2.vue";
import orderinfo2 from "../../orderManager/orderinfo2.vue";

export default {
  components: {
    dataTab,
    comment2,
    orderinfo2
  },
  data() {
    return {
      //选项卡模型
      projectState: '0',
      reasonState: 'no-reason',
      responseTimeTab: 'week',
      //curd表格data
      projectInfoByState: [],
      feedBackInfoByReason: [],
      responseTimeInfoByUnit: [],
      positionInfo: [],
      //项目字段配置
      projectTableOption: projectTableOption,
      feedBackTableOption: feedBackTableOption,
      responseTimeTableOption: responseTimeTableOption,
      positionTableOption: positionTableOption,
      //项目分页数据total
      projectTotal: 50,
      feedBackTotal: 50,
      responseTotal: 50,
      // positionTotal:50,
      //用于第三部分顶部图表显示
      responseText: '',
      //客诉原因
      reasonOptions: [],
      //data-tab 的配置
      option: {
        span: 6,
        data: [
          {
            title: '项目总数',
            subtitle: '今年',
            count: 56,
            text: '正在执行5个',
            unit: "个",
            color: 'white'
          },
          {
            title: '待解决问题数',
            subtitle: '今年',
            count: '12/56',
            text: '最久未关闭问题7天',
            color: 'white',
            unit: "个",
          },
          {
            title: '项目平均响应时间',
            subtitle: '今年',
            count: 0,
            text: '最慢响应0小时，最快响应0小时',
            color: 'white',
            unit: "小时",
          },
          {
            title: '今日师傅数',
            subtitle: '今日',
            count: 123,
            text: '安装工4人，维修工4人，搬运工3人',
            color: 'white',
            unit: "人",
          },
        ]
      },
      //环形图配置
      pieOption: {
        legend: {
          orient: 'horizontal',
          bottom: 'bottom',
          data: ['正在招募', '等待执行', '正在执行', '申请结项', '拒绝结项', '项目取消', '项目完成'],
        },
        graphic: [{　　　　　　　　　　　　//环形图中间添加文字
          type: 'text',　　　　　　　//通过不同top值可以设置上下显示
          left: 'center',
          top: '45%',
          style: {
            text: "总数",
            textAlign: 'center',
            fill: '#000',　　　　　//文字的颜色
            width: 30,
            height: 30,
            fontSize: 15,
            color: "#4d4f5c",
            fontFamily: "Microsoft YaHei"
          }
        }, {
          type: 'text',
          left: 'center',
          top: '51%',
          style: {
            text: '1000',//这里是总数量
            textAlign: 'center',
            fill: '#000',
            width: 30,
            height: 30,
            fontSize: 18,
          }
        }],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                formatter: '{b}\n{d}%\n{c}个',
                show: true
              },
            },
            lableLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              },
            },
            data: [
              {value: 310, name: '正在招募'},
              {value: 234, name: '等待执行'},
              {value: 135, name: '正在执行'},
              {value: 1548, name: '申请结项'},
              {value: 1548, name: '拒绝结项'},
              {value: 1548, name: '项目取消'},
              {value: 1548, name: '项目完成'},
            ]
          }
        ]
      },
      //雷达图配置
      radarOption: {
        title: {
          subtext: '',
          left: 'right'
        },
        // backgroundColor:'#f3f3f3',
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              color: '#000000',
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            {name: '工厂原因', max: 6500},
            {name: '客户原因', max: 3000},
            {name: '安装原因', max: 3800},
            {name: '物流原因', max: 5200},
            {name: '搬运原因', max: 1600},
            {name: '其他原因', max: 1600},
          ]
        },
        series: [{
          type: 'radar',
          data: [
            {
              value: [300, 100, 200, 100, 110, 200],
              name: '客诉原因'
            },
          ]
        }]
      },
      //折线图配置
      lineOption: {
        xAxis: {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7'],
        },
        yAxis: {
          type: 'value',
          name: '小时'
        },
        series: [{
          data: [15, 12, 31, 24, 20, 13, 2],
          type: 'line'
        }]
      },
      //地图配置
      mapOption: {
        tooltip: {
          trigger: 'item'
        },
        visualMap: {
          min: 0,
          max: 200,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],           // 文本，默认为数值文本
          calculable: true
        },
        series: [{
          name: '项目数',
          type: 'map',
          mapType: 'china',
          roam: false,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: true
            }
          },
          data: [
            {name: '北京', value: Math.round(Math.random() * 1000)},
            {name: '天津', value: Math.round(Math.random() * 1000)},
            {name: '上海', value: Math.round(Math.random() * 1000)},
            {name: '重庆', value: Math.round(Math.random() * 1000)},
            {name: '河北', value: Math.round(Math.random() * 1000)},
            {name: '河南', value: Math.round(Math.random() * 1000)},
            {name: '云南', value: Math.round(Math.random() * 1000)},
            {name: '辽宁', value: Math.round(Math.random() * 1000)},
            {name: '黑龙江', value: Math.round(Math.random() * 1000)},
            {name: '湖南', value: Math.round(Math.random() * 1000)},
            {name: '安徽', value: Math.round(Math.random() * 1000)},
            {name: '山东', value: Math.round(Math.random() * 1000)},
            {name: '新疆', value: Math.round(Math.random() * 1000)},
            {name: '江苏', value: Math.round(Math.random() * 1000)},
            {name: '浙江', value: Math.round(Math.random() * 1000)},
            {name: '江西', value: Math.round(Math.random() * 1000)},
            {name: '湖北', value: Math.round(Math.random() * 1000)},
            {name: '广西', value: Math.round(Math.random() * 1000)},
            {name: '甘肃', value: Math.round(Math.random() * 1000)},
            {name: '山西', value: Math.round(Math.random() * 1000)},
            {name: '内蒙古', value: Math.round(Math.random() * 1000)},
            {name: '陕西', value: Math.round(Math.random() * 1000)},
            {name: '吉林', value: Math.round(Math.random() * 1000)},
            {name: '福建', value: Math.round(Math.random() * 1000)},
            {name: '贵州', value: Math.round(Math.random() * 1000)},
            {name: '广东', value: Math.round(Math.random() * 1000)},
            {name: '青海', value: Math.round(Math.random() * 1000)},
            {name: '西藏', value: Math.round(Math.random() * 1000)},
            {name: '四川', value: Math.round(Math.random() * 1000)},
            {name: '宁夏', value: Math.round(Math.random() * 1000)},
            {name: '海南', value: Math.round(Math.random() * 1000)},
            {name: '台湾', value: Math.round(Math.random() * 1000)},
            {name: '香港', value: Math.round(Math.random() * 1000)},
            {name: '澳门', value: Math.round(Math.random() * 1000)}
          ]
        }
        ]
      },

    }
  },

  created: function () {
    this.getPanelData()
    this.getPieData()
    this.getReasonOptions({id: 127});
    this.fetchList({"state": this.projectState, pageNum: 1, pageSize: 10})
    this.getFeedBackInfo({"code": this.reasonState, pageNum: 1, pageSize: 10})
    this.getRadarData()
    this.getLineData({unit: this.responseTimeTab})
    this.getResponseTimeInfo({unit: this.responseTimeTab, pageNum: 1, pageSize: 10})
    this.getMapData()
    this.getPositionInfo()
  },
  mounted() {
    this.initPie()
    this.initRadar()
    this.initLine()
    this.initMap()
  },
  methods: {
    //获取并设置数据面板数据
    getPanelData() {
      getPanelData(objKeySort({})).then(response => {
        if (response.data.code == 200 && response.data.data) {
          var panelData = response.data.data;
          this.option.data[0].count = panelData[0].projectCount;
          this.option.data[0].text = '正在执行' + panelData[0].execProjectCount + '个';
          this.option.data[1].count = panelData[1].needHandleCount + '/' + panelData[1].issuesCount;
          this.option.data[1].text = '最久未关闭问题' + panelData[1].mostDelayTime + '天';
          this.option.data[2].count = panelData[2].avgResponseTime ? panelData[2].avgResponseTime : 0;
          this.option.data[2].text = '最慢响应' + (panelData[2].maxResponseTime ? panelData[2].maxResponseTime : 0) + '小时，最快响应' + (panelData[2].minResponseTime ? panelData[2].minResponseTime : 0) + '小时';
          this.option.data[3].count = panelData[3].workerCount;
          this.option.data[3].text = panelData[3].workerDetail ? panelData[3].workerDetail : '无';
        }
      })
    },
    //获取并设置饼图数据
    getPieData() {
      getPieData(objKeySort({})).then(response => {
        if (response.data.code == 200 && response.data.data) {
          var pieData = response.data.data;
          this.pieOption.series[0].data = pieData;
          var total = 0;
          for (var i = 0; i < pieData.length; i++) {
            total += pieData[i].value;
          }
          this.pieOption.graphic[1].style.text = total;
          this.initPie();
        }
      })
    },
    //获取雷达图数据
    getRadarData() {
      getRadarData(objKeySort({})).then(response => {
        if (response.data.code == 200 && response.data.data) {
          var radarData = response.data.data
          var max = 0;
          radarData.forEach(item => {
            if (item.count > max)
              max = item.count;
          });
          this.radarOption.radar.indicator = []
          this.radarOption.series[0].data[0].value = []
          radarData.forEach(item => {
            this.radarOption.radar.indicator.push({name: item.name, max: max})
            this.radarOption.series[0].data[0].value.push(item.count)
          })
          this.initRadar()
        }
      })
    },
    //获取雷达图数据
    getLineData(query) {
      getLineData(objKeySort(query)).then(response => {
        if (response.data.code == 200 && response.data.data) {
          var lineData = response.data.data;
          this.lineOption.xAxis.data = this.getArrayByCount(lineData.length)
          this.lineOption.series[0].data = []
          lineData.forEach(item => {
            this.lineOption.series[0].data.push(item.hour)
          })
          this.initLine()
        } else {
          console.log("if判断没通过")
        }
      })
    },
    getMapData() {
      getMapData(objKeySort()).then(response => {
        if (response.data.code == 200 && response.data.data) {
          var mapData = response.data.data
          console.log(mapData)
          this.mapOption.series[0].data = []
          var max = 0;
          mapData.forEach(item => {
            if (item.count > max)
              max = item.count;
            this.mapOption.series[0].data.push({name: item.province, value: item.count})
          })
          var yu = max % 50;
          max = (50 - yu) + max
          this.mapOption.visualMap.max = max
          this.initMap()
          console.log(this.mapOption.series[0].data)
        } else {
          console.log("没有通过if")
        }
      })
    },
    //初始化图表
    initPie() {
      var echarts = require('echarts');
      var myChart = echarts.init(document.getElementById('pie'));
      myChart.setOption(this.pieOption);
    },
    initRadar() {
      var echarts = require('echarts');
      var myChart = echarts.init(document.getElementById('radar'));
      myChart.setOption(this.radarOption);
    },
    initLine() {
      var echarts = require('echarts');
      var myChart = echarts.init(document.getElementById('line'));
      myChart.setOption(this.lineOption);
    },
    initMap() {
      var echarts = require('echarts');
      var myChart = echarts.init(document.getElementById('chinaMap'));
      myChart.setOption(this.mapOption);
    },
    //项目状态选项卡改变
    handleProjectStateChange(tab) {
      this.fetchList({state: this.projectState, pageNum: 1, pageSize: 10})
    },
    //客诉原因选项卡切换
    handleReasonChange(tab) {
      this.getFeedBackInfo({"code": this.reasonState, current: 1, size: 10})
    },
    //响应时间时间单位变化
    handleResponseTimeUnitChange(tab) {
      this.getLineData({unit: this.responseTimeTab})
      this.getResponseTimeInfo({unit: this.responseTimeTab, current: 1, size: 10})
    },
    getArrayByCount(times) {
      var arr = []
      for (var i = 0; i < times; i++)
        arr.push(i + 1)
      return arr;
    },
    //获取数据表格数据
    fetchList(query) {
      fetchList(objKeySort(query)).then(response => {
        if (response.data.code == 200 && response.data.data) {
          // 重组需求工种数据

          this.projectInfoByState = response.data.data.rows
          this.projectTotal = response.data.data.total
        }
      })
    },
    getFeedBackInfo(query) {
      if (query.code == 'no-reason')
        query.code = undefined
      getFeedBackInfo(objKeySort(query)).then(response => {
        if (response.data.code == 200 && response.data.data) {
          this.feedBackInfoByReason = response.data.data.records
          this.feedBackTotal = response.data.data.total
        }
      })
    },
    getResponseTimeInfo(query) {
      getProjectInfoByTimeUnit(objKeySort(query)).then(response => {
        if (response.data.code == 200 && response.data.data) {
          this.responseTimeInfoByUnit = response.data.data.records
          this.responseTotal = response.data.data.total
        }
      })
    },
    getPositionInfo(query) {
      getPositionProjectInfo(objKeySort(query))
        .then(response => {
          if (response.data.code == 200 && response.data.data) {
            this.positionInfo = response.data.data
          }
        })
    },
    //项目信息的分页事件
    projectCurrentChange(val) {
      this.fetchList({state: this.projectState, pageNum: val, pageSize: 10})
    },
    //客诉原因数据表格分页事件
    feedBackCurrentChange(val) {
      this.getFeedBackInfo({"code": this.reasonState, current: val, size: 10})
    },
    //响应时间数据表格分页事件
    responseCurrentChange(val) {
      this.getResponseTimeInfo({unit: this.responseTimeTab, current: val, size: 10})
    },
    //位置分布数据表格的分页事件
    // positionCurrentChange(val){
    // },
    //从字典中获取客诉原因列表
    getReasonOptions(query) {
      getDictListById(objKeySort(query)).then(response => {
        if (response.data.code == 200 && response.data.data) {
          this.reasonOptions = response.data.data;
          console.log(response.data.data);
          // if(response.data.data&&response.data.data.length>0){
          //   this.reasonState = response.data.data[0].code;
          // }
          this.reasonState = 'no-reason';
        }
      })
    },
    //查看反馈详情
    showFeedBack(row, event) {
      let that = this
      that.$refs.childcomment.commentstate(row.id, 2);
    },
    //查看项目详情
    showProjectDetail(row, event) {
      let that = this
      that.$refs.child.setsataus(row.projectId ? row.projectId : row.project_id, true, true);
    }

  },

}
</script>

<style lang="scss" scoped>

.main {
  background-color: rgb(245, 245, 245);

  .rowStyle {
    background-color: rgb(255, 255, 255);
    margin-left: 15px;
    margin-right: 15px;
  }

  .rowStyle1 {
    background-color: rgb(255, 255, 255);
    margin-left: 15px;
    margin-right: 15px;
    text-align: right;
    padding-right: 32px;
  }

  .responseText {
    font-size: 12px;
    color: #bfc2cc;
  }

  .tabsStyle {
    float: right;
    margin-right: 32px;
    text-overflow: hidden;
  }

  .tabsStyle1 {
    float: left;
    margin-left: 32px;

  }

  ::v-deep .el-table .cell {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .borderBottomStyle {
    border-bottom: 1px solid #F5F7FA;

  }

  ::v-deep .avue-crud__menu {
    display: none;
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 0px !important;
  }

  ::v-deep .data-tabs {
    ::v-deep .item-header {
      p {
        font-size: 12px;
      }

      span {
        position: absolute;
        right: 0;
        top: 0
      }
    }

    ::v-deep .item-footer {
      p {
        width: 100%;
      }

    }

    ::v-deep .item {
      padding: 16px;
    }
  }

  .rowStyle ::v-deep .el-pagination {
    text-align: end;
    margin-top: 20px;
  }

  ::v-deep .el-table::before {
    height: 0;
  }

  ::v-deep .el-tabs__item {
    color: rgba(144, 147, 153, 1);
  }

  ::v-deep .el-tabs__item:hover, .pro-state ::v-deep .el-tabs__item.is-active {
    color: #000;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #000;
  }

  .leftpagination {
    padding-right: 47px !important;
  }
}
</style>
